 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import OEBPSCVI from '@/components/OEBPS/cvi'
 import OEBPSTP from '@/components/OEBPS/tp'
 import OEBPSDED from '@/components/OEBPS/ded'
 import OEBPSTOC from '@/components/OEBPS/toc'
 import OEBPSPRO from '@/components/OEBPS/pro'
 import OEBPSPART1 from '@/components/OEBPS/part1'
 import OEBPSCH1 from '@/components/OEBPS/ch1'
 import OEBPSCH2 from '@/components/OEBPS/ch2'
 import OEBPSCH3 from '@/components/OEBPS/ch3'
 import OEBPSPART2 from '@/components/OEBPS/part2'
 import OEBPSCH4 from '@/components/OEBPS/ch4'
 import OEBPSCH5 from '@/components/OEBPS/ch5'
 import OEBPSCH6 from '@/components/OEBPS/ch6'
 import OEBPSCH7 from '@/components/OEBPS/ch7'
 import OEBPSCH8 from '@/components/OEBPS/ch8'
 import OEBPSCH9 from '@/components/OEBPS/ch9'
 import OEBPSCH10 from '@/components/OEBPS/ch10'
 import OEBPSPART3 from '@/components/OEBPS/part3'
 import OEBPSCH11 from '@/components/OEBPS/ch11'
 import OEBPSCH12 from '@/components/OEBPS/ch12'
 import OEBPSCH13 from '@/components/OEBPS/ch13'
 import OEBPSCH14 from '@/components/OEBPS/ch14'
 import OEBPSCH15 from '@/components/OEBPS/ch15'
 import OEBPSCH16 from '@/components/OEBPS/ch16'
 import OEBPSCH17 from '@/components/OEBPS/ch17'
 import OEBPSCH18 from '@/components/OEBPS/ch18'
 import OEBPSCH19 from '@/components/OEBPS/ch19'
 import OEBPSCH20 from '@/components/OEBPS/ch20'
 import OEBPSCH21 from '@/components/OEBPS/ch21'
 import OEBPSACK from '@/components/OEBPS/ack'
 import OEBPSATA from '@/components/OEBPS/ata'
 import OEBPSCOP from '@/components/OEBPS/cop'
 import OEBPSATP from '@/components/OEBPS/atp'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/OEBPS/cvi",
 			"name" : "OEBPS/cvi",
 			"component" : OEBPSCVI
 		},
 		{
 			"path" : "/OEBPS/tp",
 			"name" : "OEBPS/tp",
 			"component" : OEBPSTP
 		},
 		{
 			"path" : "/OEBPS/ded",
 			"name" : "OEBPS/ded",
 			"component" : OEBPSDED
 		},
 		{
 			"path" : "/OEBPS/toc",
 			"name" : "OEBPS/toc",
 			"component" : OEBPSTOC
 		},
 		{
 			"path" : "/OEBPS/pro",
 			"name" : "OEBPS/pro",
 			"component" : OEBPSPRO
 		},
 		{
 			"path" : "/OEBPS/part1",
 			"name" : "OEBPS/part1",
 			"component" : OEBPSPART1
 		},
 		{
 			"path" : "/OEBPS/ch1",
 			"name" : "OEBPS/ch1",
 			"component" : OEBPSCH1
 		},
 		{
 			"path" : "/OEBPS/ch2",
 			"name" : "OEBPS/ch2",
 			"component" : OEBPSCH2
 		},
 		{
 			"path" : "/OEBPS/ch3",
 			"name" : "OEBPS/ch3",
 			"component" : OEBPSCH3
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js